var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useRef, useEffect, useState } from 'react';
import styled, { keyframes, css } from 'styled-components';
const drawerOpening = keyframes `
  0%{
    transform: ${`translateX(${(props) => props.side * props.width}px)`};
  }
  50%{
    opacity:1;
  }
  100% {
    opacity:1;
    transform:translateX(0)
  }
`;
const drawerClosing = keyframes `
 0% {
  opacity:1;
    transform:translateX(0)
  }
  50%{
    opacity:1;
  }
  100% {
    opacity:0;
    transform: ${`translateX(${(props) => props.side * props.width}px)`};
  }
`;
const DrawerStyle = styled.div `
  opacity: 0;
  top: 0;
  ${props => props.side === -1 &&
    css `
      left: 0;
    `};
  ${props => props.side !== -1 &&
    css `
      right: 0;
    `};
  margin: 0;
  flex: 1 0 auto;
  height: 100%;
  display: flex;
  outline: 0;
  z-index: 9999;
  position: fixed;
  overflow-y: auto;
  flex-direction: column;
  padding: ${props => props.theme.paddingsMargins.themeMenuPadding};
  background-color: ${props => props.secondary ? props.theme.colors.secondaryColor : props.theme.colors.mainColor};
  width: auto;
  box-shadow: ${props => props.theme.boxes.boxShadow};
  transform: ${props => `translateX(${props.side * props.width}px)`};
  animation: ${props => css `
      ${props.openDrawer
    ? drawerOpening
    : drawerClosing} 225ms ease-in-out forwards
    `};
`;
const DrawerBackground = styled.div `
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.2);
`;
const Drawer = (_a) => {
    var { openDrawer = false, setOpenDrawer = () => { }, children, secondary = false, side = 'left' } = _a, props = __rest(_a, ["openDrawer", "setOpenDrawer", "children", "secondary", "side"]);
    const drawerRef = useRef(null);
    const [width, setWidth] = useState(0);
    const [render, setRender] = useState(openDrawer);
    useEffect(() => {
        if (openDrawer) {
            setRender(true);
        }
    }, [openDrawer]);
    useEffect(() => {
        if (render && drawerRef.current) {
            setWidth(drawerRef.current.offsetWidth);
        }
    }, [render]);
    const onAnimationEnd = () => {
        if (!openDrawer) {
            setRender(false);
        }
    };
    return (render
        ? (_jsxs(Fragment, { children: [_jsx(DrawerBackground, { onClick: () => setOpenDrawer(false) }), _jsx(DrawerStyle, Object.assign({ ref: drawerRef, secondary: secondary, openDrawer: openDrawer, width: width, onAnimationEnd: onAnimationEnd, side: side === 'left' ? -1 : 1 }, props, { children: children }))] }))
        : _jsx("div", {}));
};
export default Drawer;
